import { useEffect, useState } from "react";
import type { EffectiveThemeMode } from "../zustand/useThemeStore";

/**
 * Hook para detectar y escuchar cambios en la preferencia de tema del sistema
 */
export function useSystemTheme(): EffectiveThemeMode {
  const [systemTheme, setSystemTheme] = useState<EffectiveThemeMode>(() => {
    if (typeof window === "undefined") return "light";
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setSystemTheme(e.matches ? "dark" : "light");
    };

    // Verificar inmediatamente
    handleChange(mediaQuery);

    // Escuchar cambios
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    } else {
      // Fallback para navegadores antiguos
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  return systemTheme;
}
